import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from './services/storage.service';
import { LanguageService } from './services/language.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Jimm Monitoring Web';
  public isAuthenticated = false;
  public langSelected =  "es";

  // private roles: string[] = [];
  // isLoggedIn = false;
  // showAdmBoard = false;
  // showAdmCompBoard = false;
  // email?: string;

  constructor(private router: Router, private translocoService: TranslocoService,
              private storageService: StorageService, private langService: LanguageService) {
                this.langSelected = this.langService.getLang()
                this.translocoService.setActiveLang(this.langSelected)
               }

  // ngOnInit(): void {
  //   this.isLoggedIn = this.storageService.isLoggedIn();

  //   if (this.isLoggedIn) {
  //     const user = this.storageService.getUser();
  //     this.roles = user.roles;

  //     // this.showAdmBoard = this.roles.includes('ROLE_ADMIN');
  //     // this.showAdmCompBoard = this.roles.includes('ROLE_ADMINCOMP');

  //     this.email = user.email;
  //   }
  // }

  public logout(): void {
    this.storageService.clean();
    this.isAuthenticated = false;
    this.router.navigate(['login']);
  }
}
